import { createFileRoute } from '@tanstack/react-router'

import { exportReportDocument } from '@/components/report-viewer/export'
import { DebtReport } from '@/components/reports/debt/debt-report'
import { validateDebtReportSearch } from '@/components/reports/debt/debt-report-search'
import { ReportPage } from '@/components/reports/report-page'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/reports/debts')({
    validateSearch: validateDebtReportSearch,
    component: DebtsReportPage,
})

function DebtsReportPage() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const { hasPermission } = useAuth()
    return (
        <ReportPage title={m.debt_report_page_title()}>
            <DebtReport
                search={search}
                onSearchChange={(next) =>
                    void navigate({
                        search: (prev) => ({ ...prev, ...next }),
                        replace: true,
                    })
                }
                // Server chặn POST /reports/render bằng reports.export — thiếu
                // quyền thì ẩn hẳn nút thay vì để bấm rồi ăn 403.
                exportDocument={
                    hasPermission('reports.export')
                        ? exportReportDocument
                        : undefined
                }
            />
        </ReportPage>
    )
}
